import React from "react";
import { Stack } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import FilterSelectApi from "../FilterSelectApi";
import FilterContainer from "../FilterContainer";
import { IFilterProps } from "../../../../types/filter.type";
import FilterText from "../FilterText";
import FilterRadios from "../FilterRadios";
import FilterList from "../FilterList";

const kindOfUser: { label: string; value: string }[] = [
  {
    label: "Tất cả",
    value: "all",
  },
  {
    label: "Thông thường",
    value: "normal",
  },
  {
    label: "Quản trị viên",
    value: "admin",
  },
];

const levels: { label: string; value: string }[] = [
  {
    label: "Cấp 1",
    value: "1",
  },
  {
    label: "Cấp 2",
    value: "2",
  },
  {
    label: "Cấp 3",
    value: "3",
  },
];

const trangthais: { label: string; value: string }[] = [
  {
    label: "Tất cả",
    value: "all",
  },
  {
    label: "Ngừng hoạt động",
    value: "stop",
  },
  {
    label: "Còn hoạt động",
    value: "run",
  },
];

function FilterParticipant({ setCondition }: IFilterProps) {
  const originFilter: { [key: string]: any } = {
    email: "",
    name: "",
    userGroup: null,
    levels: [],
    kindOfUser: kindOfUser[0].value,
    trangthai: trangthais[0].value,
  };
  const [filter, setFilter] = useState(originFilter);

  const handleRefreshFilter = () => {
    setFilter(originFilter);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.email) {
      condition.email = {
        $regex: filter.email,
        $options: "i",
      };
    }
    if (filter.name) {
      condition.name = {
        $regex: filter.name.split(" ").join(".*"),
        $options: "i",
      };
    }
    if (filter.userGroup) {
      condition.group_id = filter.userGroup._id;
    }
    if (filter.kindOfUser) {
      switch (filter.kindOfUser) {
        case "normal":
          condition.admin = false;
          break;
        case "admin":
          condition.admin = true;
          break;
        default:
          break;
      }
    }
    if (filter.trangthai) {
      switch (filter.trangthai) {
        case "stop":
          condition.status = false;
          break;
        case "run":
          condition.status = true;
          break;
        default:
          break;
      }
    }
    if (filter.levels?.length > 0) {
      condition.level = { $in: filter.levels };
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <FilterContainer handleRefreshFilter={handleRefreshFilter}>
      <Stack sx={{ width: "100%" }} spacing="10px">
        <FilterText
          title="Tài khoản"
          placeholder="Tìm theo tài khoản đăng nhập"
          value={filter.email}
          onSearch={(value) => setFilter({ ...filter, email: value })}
        />
        <FilterText
          title="Tên"
          placeholder="Tìm theo tên"
          value={filter.name}
          onSearch={(value) => setFilter({ ...filter, name: value })}
        />
        <FilterSelectApi
          direction="column"
          apiCode="usergroup"
          placeholder="Chọn nhóm người dùng"
          searchFields={["group_name"]}
          title="Nhóm người dùng"
          checkEqual={(value, option) => value?._id === option?._id}
          getOptionLabel={(option) => option.group_name}
          value={filter.userGroup}
          onChange={(value) => setFilter({ ...filter, userGroup: value })}
        />
        <FilterRadios
          title="Trạng thái"
          values={trangthais}
          defaultValue={filter.trangthai}
          onChange={(val) => setFilter((prev) => ({ ...prev, trangthai: val }))}
        />
        <FilterRadios
          title="Phân loại"
          values={kindOfUser}
          defaultValue={filter.kindOfUser}
          onChange={(val) =>
            setFilter((prev) => ({ ...prev, kindOfUser: val }))
          }
        />
        <FilterList
          title="Cấp thành viên"
          items={levels}
          defaultValues={filter.levels}
          onChange={(val) => setFilter((prev) => ({ ...prev, levels: val }))}
        />
      </Stack>
    </FilterContainer>
  );
}

export default FilterParticipant;
